// TODO: remove the eslint when another transactional email is added
// Utils
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import { get, startsWith } from 'lodash';

import nwApiSdk from '../nw-api-sdk';

const { ServiceSDK } = nwApiSdk;
const EMAIL_HAC_REGISTRATION = 'home-signup-hac';

const getEventTriggeredAt = () => {
  // Date object to be used as event_triggered_at value for mailchimp events.
  const triggeredAt = new Date();
  triggeredAt.setDate(triggeredAt.getDate() + 1);

  return triggeredAt.toISOString();
};

const sendTransactionalEmail = (eventDetails) =>
  new Promise((resolve, reject) => {
    const url = `${process.env.IDENTITY_BASE_URL}/api/v1/mailchimp_email_event`;

    // Mailchimp event object
    const eventProps = {
      event_status: eventDetails.eventStatus,
      event_text: eventDetails.eventText,
      event_number: eventDetails.eventNumber,
      event_triggered_at: getEventTriggeredAt(),
    };

    const callback = (error, body) => {
      if (error) {
        reject(error);
      }

      resolve(body);
    };

    ServiceSDK.post(url, eventProps, callback, null, null);
  });

export const sendHACRegistrationEmail = () => (dispatch, getState) => {
  const isHAC = startsWith(
    get(getState(), 'routing.path'),
    '/mortgages/how-much-house-can-i-afford'
  );

  if (isHAC) {
    sendTransactionalEmail({
      eventStatus: EMAIL_HAC_REGISTRATION,
    });
  }
};
